const aynaDisclosureState = new Map();
class AynaCreationSummary extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const schedule = () => {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => { this.frame = 0; this.update(); });
    };
    ['input', 'change', 'shopify:section:load'].forEach(type =>
      document.addEventListener(type, schedule, { signal: this.controller.signal })
    );
    this.observer = new MutationObserver(records => {
      if (records.some(record => !this.contains(record.target))) schedule();
    });
    const content = document.querySelector('.product-information');
    content?.addEventListener('toggle', event => {
      if (!(event.target instanceof HTMLDetailsElement) || !event.target.matches('.ayna-choice-disclosure')) return;
      const key = event.target.querySelector('h3')?.firstChild?.textContent;
      if (key) aynaDisclosureState.set(key, event.target.open);
    }, { capture: true, signal: this.controller.signal });
    if (content) this.observer.observe(content, { childList: true, subtree: true });
    this.update();
  }
  disconnectedCallback() {
    this.controller?.abort();
    this.observer?.disconnect();
    cancelAnimationFrame(this.frame);
    this.frame = 0;
  }
  update() {
    document.querySelector('ayna-mobile-purchase-link')?.refreshTarget();
    document.querySelectorAll('.ayna-choice-disclosure').forEach(details => {
      const key = details.querySelector('h3')?.firstChild?.textContent;
      if (aynaDisclosureState.has(key)) details.open = aynaDisclosureState.get(key);
    });
    const selected = selector => document.querySelector(selector)?.value || '';
    const name = selected('input[name="properties[Prénom ou mot à créer]"]').trim();
    const nameColor = selected('input[name="properties[Couleur du prénom]"]:checked');
    const values = {
      name: name || this.dataset.emptyName,
      namecolor: nameColor || '—',
      letter: selected('input[name="ayna-letter-color-display"]:checked') || '—',
      format: selected('fieldset[data-option-id*="-taille"] input:checked') || '—',
      finish: [...document.querySelectorAll('.ayna-finish-card > input:checked')].map(input => input.value).join(' + ') || this.dataset.noFinish
    };
    for (const [key, value] of Object.entries(values)) {
      const node = this.querySelector('[data-summary-' + key + ']');
      if (node && node.textContent !== value) node.textContent = value;
    }
  }
}
class AynaMobilePurchaseLink extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const link = this.querySelector('a');
    const name = document.querySelector('input[name="properties[Prénom ou mot à créer]"]');
    const button = name?.form?.querySelector('button[name="add"]');
    if (!link || !name || !button) { this.hidden = true; return; }
    link.href = '#' + name.id;
    link.addEventListener('click', event => {
      event.preventDefault();
      const currentName = document.querySelector('input[name="properties[Prénom ou mot à créer]"]');
      if (!currentName) return;
      const target = currentName.value.trim() ? currentName.form?.querySelector('button[name="add"]') || currentName : currentName;
      target.scrollIntoView({ block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      target.focus({ preventScroll: true });
    }, { signal: this.controller.signal });
    this.observer = new IntersectionObserver(entries => { this.hidden = entries.some(entry => entry.isIntersecting); });
    this.observer.observe(button);
    this.currentButton = button;
  }
  refreshTarget() {
    if (!this.observer) return;
    const name = document.querySelector('input[name="properties[Prénom ou mot à créer]"]');
    const button = name?.form?.querySelector('button[name="add"]');
    if (!button || button === this.currentButton) return;
    this.observer.disconnect();
    this.observer.observe(button);
    this.currentButton = button;
    const link = this.querySelector('a');
    if (link && name?.id) link.href = '#' + name.id;
  }
  disconnectedCallback() {
    this.controller?.abort();
    this.observer?.disconnect();
  }
}
if (!customElements.get('ayna-creation-summary')) customElements.define('ayna-creation-summary', AynaCreationSummary);
if (!customElements.get('ayna-mobile-purchase-link')) customElements.define('ayna-mobile-purchase-link', AynaMobilePurchaseLink);

